import { createAction } from 'typesafe-actions';
import { MyContactsState } from './types';

export const SET_STATE_CONTACT = 'SET_STATE_CONTACT';
export const setStateContacts =
  createAction(SET_STATE_CONTACT)<MyContactsState>();
